<template>
    <div>
        Settings
    </div>
</template>

<script>
    export default {
        name: 'SettingsView',

        setup() {

        }
    }
</script>

<style lang="scss" scoped>

</style>